/**
 * The closed sets outreach answers in, shared by the platform and the
 * interface (proposal 0007).
 *
 * A runtime list rather than a type alone, for the reason `DENY_REASONS`
 * is one: the interface's test asserts it has words for every code, and a
 * test cannot iterate a type. `@norum/outreach` derives its union from this
 * list, so a code added there without words here fails the build on one
 * side and the test on the other.
 */
/**
 * The department outreach belongs to: the folder its markets file lives in
 * (`ledger/departments/<this>/markets.yaml`). Named once, so the file's path
 * and the interface's doors cannot come to disagree (audit A-9).
 */
export const OUTREACH_DEPARTMENT = 'outbound';
/** Why a first touch may not leave now — `isSendable`'s refusals. */
export const PACE_REFUSAL_CODES = [
    'market_not_declared',
    'legal_basis_unconfirmed',
    'consent_required',
    'market_disabled',
    'personal_address_not_permitted',
    'zone_not_in_market',
    'weekend',
    'public_holiday',
    'quiet_period',
    'outside_window',
    'daily_ceiling',
    'too_soon',
    'no_slot_within_horizon',
];
/** Refusals that time alone lifts — the interface shows these as "not yet", never red. */
export const PACE_CODES_TIME_LIFTS = new Set([
    'weekend',
    'public_holiday',
    'quiet_period',
    'outside_window',
    'daily_ceiling',
    'too_soon',
]);
/** Why an address is on the suppression register (ADR-0081, proposed). */
export const SUPPRESSION_REASONS = ['unsubscribed', 'objected', 'bounced_hard', 'complained', 'manual'];
//# sourceMappingURL=outreach.js.map